// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { ClientApplication } from '../../client';
import type {
  Director,
  DirectorData,
  DirectorPatch,
  DirectorQuery,
  DirectorService,
  DirectorSearchResult,
  DirectorSearchResults,
  KnownForItem,
} from './director.class';

export type {
  Director,
  DirectorData,
  DirectorPatch,
  DirectorQuery,
  DirectorSearchResult,
  DirectorSearchResults,
  KnownForItem,
};

export type DirectorClientService = Pick<DirectorService, (typeof directorMethods)[number]>;

export const directorPath = 'api/director';

export const directorMethods: Array<keyof DirectorService> = [
  'find',
  'get',
  'create',
  'patch',
  'remove',
];

export const directorClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(directorPath, connection.service(directorPath), {
    methods: directorMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [directorPath]: DirectorClientService;
  }
}
